import React from "react";
import { useTranslation } from "react-i18next";

const Stops = () => {
  const { t } = useTranslation();

  return (
    <div className="list-trip">
      <h4>{t("titleStops")}</h4>
      <ul className="list-unstyled p-0 m-0">

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="radio" name="flexRadioDefault" id="gridCheck" />
              <label className="form-check-label" htmlFor="gridCheck">
                <span className="d-block">{t("any")}</span>
                {t("from", { price: "INR53,805.36" })}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">654</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="radio" name="flexRadioDefault" id="gridCheck2" />
              <label className="form-check-label" htmlFor="gridCheck2">
                <span className="d-block">{t("directStops")}</span>
                {t("from", { price: "INR53,805.36" })}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">54</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="radio" name="flexRadioDefault" id="gridCheck3" />
              <label className="form-check-label" htmlFor="gridCheck3">
                <span className="d-block">{t("oneStop")}</span>
                {t("from", { price: "INR53,805.36" })}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">102</div>
          </div>
        </li>

      </ul>
    </div>
  );
};

export default Stops;
